export const MARITAL_STATUS = [
  { id: 0, text: "Not Set" },
  { id: 1, text: "Single" },
  { id: 2, text: "Married" },
  { id: 3, text: "Widowed" },
  { id: 4, text: "Divorced" },
];
